import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
type Sale = {
  name: string;
  location: string;
  pack: string;
  timeAgo: string;
};
const sales: Sale[] = [{
  name: 'Lucía M.',
  location: 'Buenos Aires',
  pack: 'Pack + Clases Grabadas',
  timeAgo: 'hace 2 minutos'
}, {
  name: 'María F.',
  location: 'Córdoba',
  pack: 'Pack Arte Bordado',
  timeAgo: 'hace 4 minutos'
}, {
  name: 'Camila R.',
  location: 'Rosario',
  pack: 'Pack + Clases Grabadas',
  timeAgo: 'hace 6 minutos'
}, {
  name: 'Sofía L.',
  location: 'Mendoza',
  pack: 'Pack Arte Bordado',
  timeAgo: 'hace 8 minutos'
}, {
  name: 'Valentina P.',
  location: 'La Plata',
  pack: 'Pack + Clases Grabadas',
  timeAgo: 'hace 11 minutos'
}, {
  name: 'Florencia G.',
  location: 'Tucumán',
  pack: 'Pack + Clases Grabadas',
  timeAgo: 'hace 13 minutos'
}, {
  name: 'Martina B.',
  location: 'Salta',
  pack: 'Pack Arte Bordado',
  timeAgo: 'hace 17 minutos'
}, {
  name: 'Agustina V.',
  location: 'Mar del Plata',
  pack: 'Pack + Clases Grabadas',
  timeAgo: 'hace 20 minutos'
}, {
  name: 'Julieta D.',
  location: 'San Juan',
  pack: 'Pack + Clases Grabadas',
  timeAgo: 'hace 23 minutos'
}, {
  name: 'Carolina S.',
  location: 'Neuquén',
  pack: 'Pack Arte Bordado',
  timeAgo: 'hace 25 minutos'
}, {
  name: 'Antonella T.',
  location: 'Santa Fe',
  pack: 'Pack + Clases Grabadas',
  timeAgo: 'hace 28 minutos'
}, {
  name: 'Brenda C.',
  location: 'Bahía Blanca',
  pack: 'Pack Arte Bordado',
  timeAgo: 'hace 32 minutos'
}];
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    // Initial show after 4 seconds
    const initial = setTimeout(() => setVisible(true), 4000);
    // Every 15 seconds: hide → change → show
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex(i => (i + 1) % sales.length);
        setVisible(true);
      }, 500);
    }, 15000);
    // Auto-hide each popup after 6 seconds
    const autoHide = setInterval(() => {
      setVisible(false);
    }, 15000 + 6000); // offset
    return () => {
      clearTimeout(initial);
      clearInterval(cycle);
      clearInterval(autoHide);
    };
  }, [dismissed]);
  // Auto-hide effect — show for 6s of each 15s cycle
  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => setVisible(false), 6000);
    return () => clearTimeout(t);
  }, [visible]);
  if (dismissed) return null;
  const sale = sales[index];
  return <div role="status" aria-live="polite" className={`fixed left-3 bottom-3 md:left-5 md:bottom-5 z-40 max-w-[280px] md:max-w-xs transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`} data-id="element-272">
      <div className="bg-white rounded-xl shadow-soft border border-brand-pink/20 p-3 flex items-start gap-2.5" data-id="element-273">
        <div className="bg-brand-pink/10 rounded-full p-1.5 shrink-0" data-id="element-274">
          <CheckCircleIcon className="text-brand-pink" style={{
          fontSize: 18
        }} data-id="element-275" />
        </div>
        <div className="flex-grow min-w-0" data-id="element-276">
          <p className="text-[12px] md:text-xs font-bold text-brand-dark leading-tight" data-id="element-277">
            {sale.name}{' '}
            <span className="font-normal text-gray-500" data-id="element-278">
              de {sale.location}
            </span>
          </p>
          <p className="text-[11px] md:text-xs text-brand-purple font-medium leading-snug mt-0.5" data-id="element-279">
            compró el {sale.pack}
          </p>
          <p className="text-[10px] text-gray-400 mt-0.5" data-id="element-280">✓ {sale.timeAgo}</p>
        </div>
        <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar" className="text-gray-300 hover:text-gray-500 shrink-0 -mr-1 -mt-1" data-id="element-281">
          <CloseIcon style={{
          fontSize: 16
        }} data-id="element-282" />
        </button>
      </div>
    </div>;
}